import { useEffect } from "react";
import { BreadCrumbItemType } from "../common/types";
import { useAppDispatch, useAppSelector } from "./store";
import {
  addBreadCrumbThunk,
  removeBreadCrumbThunk,
} from "../store/thunks/common.thunk";

export const useBreadCrumbHook = (item: BreadCrumbItemType[]) => {
  const { breadCrumb } = useAppSelector(
    (state) => state.rootReducer.commonReducer
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(addBreadCrumbThunk(item));

    return () => {
      dispatch(removeBreadCrumbThunk(item));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return [breadCrumb];
};

export function useOutsideClick(ref: any, onClickOut: () => void, deps = []) {
  useEffect(() => {
    const onClick = ({ target }: any) =>
      !ref?.contains(target) && onClickOut?.();
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

// useEffect(() => {
//   const handleClickOutside = (event: MouseEvent) => {
//     if (
//       dropdownRef.current &&
//       !(dropdownRef.current as HTMLElement).contains(event.target as Node)
//     ) {
//       setDropdownOpen(false);
//     }
//   };
//   document.addEventListener("mousedown", handleClickOutside);
//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, [dropdownRef]);
